import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LANDINGSECTION from "./constants/LandingConstant";
import routes from "./routes";
import NavBar from "./components/NavBar";
import { AuthenticatedTemplate } from "@azure/msal-react";
import NoMatch from "./components/Landing/NoMatch";
import { AuthProvider } from "./AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NavBarAndLandingPageProvider } from "./NavBarContextAndLandingPageContext";
import AppWrapper from "./AppWrapper";
import Footer from "./components/Footer/Footer";


const RouteHandler = () => {
  const menu = routes.map((route, index) => {
    return route.component ? (
      <Route
        key={index}
        path={route.path}
        exact={route.exact}
        name={route.name}
        element={route.component}
      />
    ) : null;
  });
  return (
    <>
      <AuthenticatedTemplate>
        <AuthProvider>
          <NavBarAndLandingPageProvider>
            <NavBar />
            <AppWrapper>
              <Routes>
                {menu}
                <Route
                  index
                  element={
                    <Navigate replace to={LANDINGSECTION.DATABOOK_LANDING_URL} />
                  }
                />
                <Route path="*" element={<NoMatch />} />
              </Routes>
            </AppWrapper>
            <Footer />
          </NavBarAndLandingPageProvider>
        </AuthProvider>
        <ToastContainer />
      </AuthenticatedTemplate>
    </>
  );
};

export default RouteHandler;
